'use client'

import React from 'react'

// Комментарий на русском: ненавязчивый индикатор офлайна — НЕ блокирует интерфейс.
export default function OfflineBanner() {
  const [offline, setOffline] = React.useState(false)

  React.useEffect(() => {
    const update = () => setOffline(typeof navigator !== 'undefined' && navigator.onLine === false)
    update()
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
    }
  }, [])

  if (!offline) return null

  return (
    <div
      className="fixed left-0 right-0 z-[80] flex justify-center pointer-events-none"
      style={{ top: 'calc(env(safe-area-inset-top, 0px) + 10px)' }}
    >
      <div className="mx-3 rounded-xl border border-site-border bg-site-bg/55 px-3 py-2 text-xs text-site-text backdrop-blur-md">
        Нет сети — работаем офлайн
      </div>
    </div>
  )
}


